// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"190":"8edd5701","240":"0beb9953","271":"6f991049","363":"67c14bbb","425":"b33e86f9","453":"2f7c059a","464":"3d33e743","498":"672ff73f","541":"59801ea6","624":"58ef1d5f","912":"853343fd"}[chunkId] + ".chunk.js";
};